export default "__VITE_ASSET__l4RQN5EH__"